<template>
  <div>
    <select-condition style="margin-bottom: 30px" />
    <select-result />
  </div>
</template>

<script>
import SelectCondition from '../SelectConditionUnit'
import SelectResult from '../SelectResultUnit'
export default {
  name: 'UnitPolicy',
  components: { SelectCondition, SelectResult },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
